/**
 * [FN — DECIDED] Explicit mapping from the host app's location names (the
 * `name` field of SelectedLocation, written by the nav's select-location
 * component) to the SOF.StorageFacilities values the SOF endpoints expect.
 *
 * NO fuzzy matching, ever: an unmapped location returns null and the queue
 * shows a clear "no storage facility" empty state instead of guessing.
 *
 * !IMPORTANT! The right-hand values must be verified against
 * GET /V1/sof-receiving/storage-facilities (SOF.StorageFacilities) before
 * launch. They currently assume the facility names equal the host location
 * labels (e.g. 'Norfolk', which MM.ReceivingLog's SQL also uses as its
 * facility default). If the DB values differ, fix them HERE only.
 */
export const HOST_LOCATION_TO_STORAGE_FACILITY: Record<string, string> = {
  kent: 'Kent',
  kennewick: 'Kennewick',
  portland: 'Portland',
  sntWarehouse: 'SNT Warehouse',
  spokane: 'Spokane',
  norfolk: 'Norfolk',
};

/**
 * Resolves the host location name to its SOF storage-facility value.
 *
 * @param hostLocationName - The SelectedLocation.name value from the host app.
 * @returns The SOF.StorageFacilities value, or null when the location has no
 * corresponding storage facility (drives the queue's empty state).
 */
export function toStorageFacility(
  hostLocationName: string | null | undefined
): string | null {
  if (!hostLocationName) {
    return null;
  }
  return HOST_LOCATION_TO_STORAGE_FACILITY[hostLocationName] ?? null;
}
